<template>
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-plus-fill" viewBox="0 0 16 16">
  <path
     d="m 4,16 h 7 a 2,2 0 0 0 2,-2 2,2 0 0 0 2,-2 V 2 A 2,2 0 0 0 13,0 H 6 A 2,2 0 0 0 4,2 2,2 0 0 0 2,4 v 10 a 2,2 0 0 0 2,2 z M 4,3 v 9 a 2,2 0 0 0 2,2 h 6 a 1,1 0 0 1 -1,1 H 4 A 1,1 0 0 1 3,14 V 4 A 1,1 0 0 1 4,3 Z m 10,9 a 1,1 0 0 1 -1,1 H 6 A 1,1 0 0 1 5,12 V 2 A 1,1 0 0 1 6,1 h 7 a 1,1 0 0 1 1,1 z"
     id="path2"
  />
</svg>
</template>

<script>
// https://icons.getbootstrap.com/icons/files/  (then rotated 180 degrees)

export default {
  name: "Copy"
}
</script>

<style>

</style>